import React, {
  useMemo,
  useEffect,
  useState,
  useCallback,
  useImperativeHandle,
  useContext,
  useRef,
} from 'react'
import { useParams } from 'react-router-dom'
import {
  useTable,
  useRowSelect,
  useFilters,
  // useGlobalFilter,
} from 'react-table'
import clsx from 'clsx'
import { Modal, Toast } from '@ow/comps'
import {
  deleteUsers,
  approvedUser,
  rejectUser,
  checkIsUsersHasCase,
} from '@vt/apis/lib-ex/v2/users'
import { useProjectStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { FixedSizeList } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import { css } from '@emotion/css'
import UserItem from './TableItem'
import Checkbox from '../../CheckBox'
import EditUser from '../EditUser'
import UpdatePwdModal from '../UpdatePwdModal'
import QuitModal from '../QuitModal'
import OrgContext from '../../../hooks/org/context'

// 禁用、删除功能需加二次校验
// 暂未实现 通过、拒绝、交接、移除等
// 筛选功能暂时注释
const UserTable = function ({
  users,
  fetchUsers,
  updateCheckedUser,
  tableRef,
  useUserApi = {},
}) {
  const { appId } = useParams()
  const popupRef = useRef(null)
  const pwdPopupRef = useRef(null)
  const { roles } = useContext(OrgContext) || {}
  // 操作
  const { userOperate } = useUserApi
  const { disableUser, activeUser, updatePwd } = userOperate
  const [currentUser, setCurrentUser] = useState({})
  const [isVisibleQuitModal, setIsVisibleQuitModal] = useState(false)
  // 筛选
  const [currentSelRole, setCurrentSelRole] = useState('')

  // 暂未实现
  // eslint-disable-next-line no-unused-vars
  const cloumsFilter = ({ column: { id, setFilter, filterValue } }) => {
    console.log(filterValue, 'filterValue')
    const roleOptions = [{ value: 'all', label: '全部' }]
    const options =
      id === 'status'
        ? [
            { value: 'all', label: '全部' },
            { value: -1, label: '未激活' },
            { value: 0, label: '待审批' },
            { value: 1, label: '正常' },
          ]
        : roleOptions.concat(roles || [])
    return (
      <Modal
        trigger={<span id={id}>点击</span>}
        position="bottom center"
        closeOnDocumentClick
        arrow={false}
        contentStyle={{
          width: '7rem',
          padding: 0,
          marginTop: '0.9rem',
          border: 'none',
          borderRadius: '0.3125rem',
          boxShadow: '0px 1px 10px -1px rgba(0,0,0,0.20)',
        }}
      >
        <div className="w-full flex flex-col mb-1">
          {options.map((item) => {
            const styles =
              filterValue === item.value ||
              (filterValue === undefined && item.value === 'all')
                ? 'w-full bg-blue-2 py-1 px-2 text-sm cursor-pointer text-blue-1 mt-1'
                : 'w-full hover:bg-gray-100 py-1 px-2 text-sm cursor-pointer mt-1'

            return (
              <div
                className={styles}
                key={item.value}
                style={{ fontSize: '0.8rem' }}
                onClick={() => {
                  setFilter(item.value)
                  setCurrentSelRole(
                    id === 'status' && item.value !== 'all' ? item.value : ''
                  )
                  setTimeout(() => {
                    document.getElementById(id).click()
                  }, 200)
                }}
              >
                {item.label}
              </div>
            )
          })}
        </div>
      </Modal>
    )
  }
  const datas = useMemo(() => users || [], [users])
  const columns = useMemo(
    () => [
      {
        id: 'name',
        Header: '用户姓名',
        accessor: 'name',
      },
      {
        id: 'username',
        Header: '用户名',
        accessor: 'username',
      },
      {
        id: 'mobile',
        Header: '手机号',
        accessor: 'mobile',
      },
      {
        id: 'org',
        Header: '组织',
        accessor: 'org',
      },
      {
        id: 'role',
        Header: '角色',
        accessor: 'role',
        // Filter: cloumsFilter,
        filter: (rows, columnIds, filterValue) => {
          return filterValue === 'all'
            ? rows
            : rows.filter((item) => {
                const { original } = item
                return original.roleSlug === filterValue
              })
        },
      },
      {
        id: 'status',
        Header: '状态',
        accessor: 'status',
        // Filter: cloumsFilter,
        filter: (rows, columnIds, filterValue) => {
          return filterValue === 'all'
            ? rows
            : rows.filter((item) => {
                const { original } = item
                return Number(original.status) === filterValue
              })
        },
      },
      {
        id: 'operate',
        Header: '操作',
        accessor: 'operate',
      },
    ],
    [roles, currentSelRole]
  )

  const tableInstance = useTable(
    { columns, data: datas },
    useFilters,
    // useGlobalFilter,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push(() => [
        {
          id: 'selection',
          // eslint-disable-next-line react/no-unstable-nested-components
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <Checkbox {...getToggleAllRowsSelectedProps()} />
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          Cell: ({ row }) => <Checkbox {...row.getToggleRowSelectedProps()} />,
        },
        ...columns,
      ])
    }
  )
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    toggleAllRowsSelected,
  } = tableInstance

  const closeQuitModal = () => {
    setIsVisibleQuitModal(false)
    setCurrentUser({})
  }

  // eslint-disable-next-line no-unused-vars
  const onClickDelete = () => {
    // 先检查是否有案件
    checkIsUsersHasCase([currentUser.id]).then((data) => {
      if (data[currentUser.id]) {
        // 有案件，需交接
        setIsVisibleQuitModal(true)
      } else {
        deleteUsers([currentUser.id]).then(() => {
          fetchUsers()
        })
      }
    })
  }

  // 操作
  const onOperateUser = (obj, opt) => {
    setCurrentUser(obj || {})
    if (obj && Object.keys(obj).length > 0) {
      if (opt === 'edit') {
        if (popupRef.current) {
          popupRef.current.open()
        }
      } else if (opt === 'pass') {
        approvedUser([obj.id]).then(() => {
          fetchUsers()
        })
      } else if (opt === 'refuse') {
        rejectUser([obj.id]).then(() => {
          fetchUsers()
        })
      } else if (opt === 'delete') {
        deleteUsers(appId, [obj.id]).then(() => {
          fetchUsers()
          Toast.success({ title: '删除成功' })
        })
      } else if (opt === 'pwd') {
        if (pwdPopupRef.current) {
          pwdPopupRef.current.open()
        }
      } else if (opt === 'enable') {
        if (obj.active) {
          // 禁用
          disableUser([obj.id])
        } else {
          // 启用
          activeUser([obj.id])
        }
      } else {
        // 离职
        setIsVisibleQuitModal(true)
      }
    }
  }

  useImperativeHandle(tableRef, () => ({
    cancleSeletedUsers: () => {
      toggleAllRowsSelected(false)
    },
  }))
  const [isAdmin, setIsAdmin] = useState(false)
  const { userInfo } = useProjectStore((s) => pick(s, ['userInfo']))

  const renderRow = useCallback(
    ({ index, style }) => {
      const row = rows[index]
      prepareRow(row)
      return (
        <UserItem
          style={style}
          key={row.original.id}
          isAdmin={isAdmin}
          row={row}
          onOperateUser={onOperateUser}
        />
      )
    },
    [prepareRow, rows, selectedFlatRows, isAdmin]
  )

  useEffect(() => {
    const checkedUsers = selectedFlatRows.map((d) => d.original)
    updateCheckedUser(checkedUsers)
  }, [selectedFlatRows])

  // 解决火狐浏览器高度的问题
  useEffect(() => {
    const str = navigator.userAgent
    console.log(document.body.clientHeight, 'lll')
    if (str.indexOf('Firefox') > -1) {
      document.getElementById('user-list').style.height = `${
        document.body.clientHeight - 180
      }px`
    }
  }, [])
  useEffect(() => {
    if (userInfo && userInfo.roleName === '管理员') {
      setIsAdmin(true)
    }
  }, [userInfo])
  return (
    <div
      className="w-full relative overflow-x-auto"
      style={{
        height: 'calc(100% - 3.8625rem)',
        fontSize: '13px',
        color: '#526484',
      }}
    >
      <div
        {...getTableProps()}
        className="table w-full h-full overflow-x-auto sm:overflow-x-visible"
        style={{ position: 'relative' }}
      >
        {headerGroups.map((headerGroup) => {
          return (
            <div
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.headers}
              className="flex pl-4"
              style={{
                fontSize: '13px',
                borderBottom: '1px solid #dbdfea',
                borderTop: '1px solid #dbdfea',
              }}
            >
              {headerGroup.headers.map((column) => {
                return (
                  <div
                    {...column.getHeaderProps()}
                    key={column.id}
                    className={clsx([
                      {
                        'w-32 lg:w-1/6': column.id !== 'selection',
                        'w-10': column.id === 'selection',
                      },
                      'flex items-center p-2',
                    ])}
                  >
                    <b>{column.render('Header')}</b>
                    {/* <div>
                        {column.id === 'status' || column.id === 'role'
                          ? column.render('Filter')
                          : null}
                      </div> */}
                  </div>
                )
              })}
            </div>
          )
        })}
        <div
          {...getTableBodyProps()}
          className={css`
            height: calc(100% - 5.1125rem);
            clear: both;
          `}
          id="user-list"
        >
          {rows.length > 0 && (
            <AutoSizer>
              {({ height, width }) => {
                return (
                  <FixedSizeList
                    height={height}
                    itemCount={rows.length}
                    itemSize={47}
                    width={width}
                  >
                    {renderRow}
                  </FixedSizeList>
                )
              }}
            </AutoSizer>
          )}
        </div>
      </div>
      <div
        className="w-full px-5 text-gray-600 text-xs flex items-center absolute left-0 bottom-0"
        style={{ height: '2.25rem' }}
      >
        共查询到{users.length}条数据
      </div>

      <EditUser
        appId={appId}
        user={currentUser}
        closeModal={() => {
          if (popupRef.current) {
            popupRef.current.close()
            setCurrentUser({})
          }
        }}
        updateCurrentUser={onOperateUser}
        useUserApi={useUserApi}
        ref={popupRef}
      />

      <UpdatePwdModal
        user={currentUser}
        closeModal={() => {
          if (pwdPopupRef.current) {
            pwdPopupRef.current.close()
            setCurrentUser({})
          }
        }}
        updatePwd={updatePwd}
        ref={pwdPopupRef}
      />
      {/* 离职 */}
      {isVisibleQuitModal && (
        <QuitModal
          open={isVisibleQuitModal}
          user={currentUser}
          closeModal={closeQuitModal}
          fetchUsers={fetchUsers}
        />
      )}
    </div>
  )
}

export default UserTable
